<template>
  <div>
    <div v-if="isMobileDevice" class="overlay mobile_only"></div>
    <div class="fixed_page"  id="blurry">
      <div class="get-started">
        <div class="home-main">
          <div class="fixed_page">

            <div class="home_stats_box">
              <div class="home_edit_icon_bg" @click.prevent="toEdit()" style="cursor: pointer">
                <img src="static/images/home/icon-edit.svg" class="home_edit_icon">
              </div>
              <div class="home_row flex-row">
                <div class="flex-column">
                  <img :src= "userDetails.avatar"  class="avatar_home">
                </div>
                <div class="flex-column home_user_info">
                  <h4>{{ userDetails.username }}</h4>
                </div>
              </div>
              <div class="home_stats_row">
                <div class="home_stats">
                  <p> {{ userDetails.level }} </p>
                  <label> {{ getTranslations.home_player_level }} </label>
                </div>
                <div class="vertical_line_home"></div>
                <div class="home_stats">
                  <p> {{ formattedValue(userDetails.totalPointsEarned) }} </p>
                  <label> {{ getTranslations.home_collected_points }} </label>
                </div>
                <div class="vertical_line_home"></div>
                <div class="home_stats">
                  <p> {{ userDetails.gamesPlayed }} </p>
                  <label> {{ getTranslations.home_profile_profile_games }} </label>
                </div>
              </div>
              <button class="fb_bg" v-if="facebookFunctionality">
                <div class="home_row">
                  <img src="static/images/home/logo-facebook.svg">
                  <p> {{ getTranslations.visitor_facebook_login_connect_before_points }} <br>
                    {{ getTranslations.visitor_facebook_login_connect_before_points_to_earn }}
                    {{ connectionPoints }} {{ getTranslations.visitor_facebook_login_connect_after_points }}</p>
                </div>
              </button>
              <div class="games_left_row">
                <p @click.prevent="openUnlockedModal" style="cursor: pointer"><span>{{ userDetails.availableGames }}</span>
                  {{ getTranslations.home_games_left }} </p>
                <a v-if="!hideStore" @click.prevent="toStorePage" style="cursor: pointer">{{ getTranslations.home_buy_games }}</a>
              </div>
            </div>
            <div class="home_play_outer">
              <div class="home_play_outer2">
                <div class="home_play_outer3">
                  <a class="home_play_btn" style="cursor:pointer" @click.prevent="navigateToGameIntro('SWIPO')">{{ getTranslations.home_start_game }}</a>
                </div>
              </div>
            </div>
            <!-- start_circle -->
            <div class="circle_background">

              <div class="home_prizes_section">
                <div class="col-lg-12">
                  <h1> {{ getTranslations.home_train_brain }} <span class="make_bold">
                    {{ getTranslations.home_win_more }} </span></h1>
                  <p> {{ getTranslations.home_unlock_chance_win }}
                    <span class="make_bold"> {{ getTranslations.home_grand_prize_draw }} </span>
                    {{ getTranslations.home_grand_prize_worth }} <span class="make_bold">
                      {{ getTranslations.visitor_grand_prize_value }}</span></p>
                </div>
                <div class="col-lg-12">
                  <h1><span class="make_bold prizes_home_title"> {{ getTranslations.home_home_prizes }} </span></h1>
                  <p> {{ getTranslations.home_check_prizes }} </p>
                </div>
              </div>

              <carousel></carousel>

              <div class="desktop_only" v-if="!!phaseBonusList.length">
                <span v-for="(phase,index) in phaseBonusList" :key="index">
                  <bonus-box v-if="phase.type === 'BUNDLES'" :phase=phase :is-midnight-bonus="false" @isMobileDeviceMethod="isMobileDevice = false"></bonus-box>
                  <bonus-box v-if="phase.type === 'POINTS'" :phase=phase :is-midnight-bonus="true" @isMobileDeviceMethod="isMobileDevice = false"></bonus-box>
                </span>
              </div>
              <div class="mobile_only" v-if="!!phaseBonusList.length">
                <span v-for="(phase, index) in phaseBonusList" :key="index">
                  <bonus-box-mobile v-if="phase.type === 'BUNDLES'" :phase=phase :index=index
                                    :length=phaseBonusList.length :is-midnight-bonus="false" @isMobileDeviceMethod="isMobileDevice = true"></bonus-box-mobile>
                  <bonus-box-mobile v-if="phase.type === 'POINTS'" :phase=phase :index=index
                                    :length=phaseBonusList.length :is-midnight-bonus="true" @isMobileDeviceMethod="isMobileDevice = true"></bonus-box-mobile>
                </span>
              </div>
              <achievements-profile :has-filters="true"></achievements-profile>
            </div>
            <!-- end circle -->
          </div>
        </div>
      </div>
    </div>
    <div class="bonus_phase_outer" v-if="showOptOutPhase">
      <div class="bonus_phase promo_phase_fp" id="optout">
        <div class="bonus_phase_inner ">
          <div class="promo_phase_outer">
            <div class="bonus_phase_content promo_phase_fp">
              <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_message') }} <a class="optout__link" @click.prevent="toEdit">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_click_here') }}</a></p>
            </div>
          </div>
        </div>
        <button class="bonusclose"  id="bonusclose" @click="closeBannerForOptout()"></button>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapMutations, mapState } from 'vuex';
import { closeBanner } from '@/common/jQuery';
import 'owl.carousel';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import modals from '@/common/modals';
import PreGameModal from './modals/pregame/PreGameModal';
import UnlockedGamesModal from './modals/unlockedgames/UnlockedGamesModal';
import UnlockedGamesZeroBalanceModal from './modals/unlockedgames/UnlockedGamesZeroBalanceModal';
import Carousel from './Carousel';
import BonusBox from './BonusBox';
import BonusBoxMobile from './BonusBoxMobile';
import GamesCarouselMobile from './GamesCarouselMobile';
import AchievementsProfile from './profile/AchievementsProfile';


export default {
  name: 'default-content',
  components: {
    AchievementsProfile,
    GamesCarouselMobile,
    BonusBox,
    UnlockedGamesZeroBalanceModal,
    UnlockedGamesModal,
    PreGameModal,
    Carousel,
    BonusBoxMobile,
  },
  data() {
    return {
      isMobileDevice: false,
    };
  },
  mixins: [NumbersFormattingMixin],
  beforeDestroy() {
    this.setBonusPhasesNum(this.phaseBonusList.length);
  },
  mounted() {
    closeBanner();
  },
  methods: {
    ...mapMutations('game', [
      'updateGameType',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'setBonusPhasesNum',
    ]),
    formattedValue(intValue) {
      if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
        return intValue.toLocaleString();
      }
      return intValue;
    },
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    toStorePage() {
      this.$router.push('/home/store');
    },
    closeBannerForOptout() {
      closeBanner();
    },
    openUnlockedModal() {
      if (this.userDetails.availableGames !== 0) this.storeModalForHomePage(UnlockedGamesModal);
      else this.storeModalForHomePage(UnlockedGamesZeroBalanceModal);
      modals.showHideModal(this);
    },
    navigateToGameIntro(game) {
      this.storeModalForHomePage(PreGameModal);
      this.updateGameType(game);
      modals.showHideModal(this);
    },
  },
  computed: {
    ...mapState('common', [
      'modalForHomePage',
      'availableIntegrations',
      'integrationHeader',
      'hideStore',
      'hideJackpot',
      'userDetails',
      'connectionPoints',
      'facebookFunctionality',
      'showOptOutPhase',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapState('profile', [
      'phaseBonusList',
      'bonusPhasesNum',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue